<template>
    <b-modal v-model="show" :title="$t('auto.addCoefficientForDilapidation')" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Эксрерт эскириш учун коеффициент <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.coefficientForExpertDilapidation" :precision="2"
                                       :class="{invalid : $v.dictionaryData.data.coefficientForExpertDilapidation.$error}">
                        </numeric-input>
                    </div>
                    <div class="form-group">
                        <label>Йили ва босиб ўтган йўли бўйича эскириш учун коеффициент <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.coefficientForAgeMileageDilapidation" :precision="2"
                                       :class="{invalid : $v.dictionaryData.data.coefficientForAgeMileageDilapidation.$error}">
                        </numeric-input>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>


<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';
    import { required } from 'vuelidate/lib/validators'
    export default {
        name: "CoefficientForDilapidationEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                show: false,
                processing: false,
                numericTypes: numericTypes,
                dictionaryData: {
                    id: null,
                    dictionaryType: 'COEFFICIENT_FOR_DILAPIDATION',
                    data: {
                        coefficientForExpertDilapidation: null,
                        coefficientForAgeMileageDilapidation: null
                    }
                }
            }
        },
        validations: {
            dictionaryData: {
                data: {
                    coefficientForExpertDilapidation: {
                        required
                    },
                    coefficientForAgeMileageDilapidation: {
                        required
                    }
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                if ((this.dictionaryData.data.coefficientForExpertDilapidation + this.dictionaryData.data.coefficientForAgeMileageDilapidation) !== 1){
                    return false;
                }

                this.$http.post('dictionary/save', this.dictionaryData)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('taxChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
        },
        created() {
            this.$eventBus.$on('CoefficientForDilapidationEditModal', (data) => {
                if (data) {
                    this.dictionaryData.id = data.id;
                    this.dictionaryData.data = clone(data.data);
                } else {
                    this.dictionaryData.id = null;
                    this.dictionaryData.data = {
                        coefficientForExpertDilapidation: null,
                        coefficientForAgeMileageDilapidation: null
                    };
                }
                this.show = true;
            });
        }
    }
</script>
<style scoped>

</style>